import { render, staticRenderFns } from "./PortalNavbar.vue?vue&type=template&id=fa1156d8"
import script from "./PortalNavbar.vue?vue&type=script&lang=js"
export * from "./PortalNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports